export const EVENT_TYPES = {
  block: "block",
  flexible: "flexible",
  continuous: "continuous",
  onDemand: "on_demand",
};

export const courseTypes = ({ events }) =>
  (events || []).reduce(
    (unique, { typeOf }) => (unique.includes(typeOf) ? unique : [...unique, typeOf]),
    [],
  );

export const typeOfEvents = (events, typeOf) => events.filter(event => event.typeOf === typeOf);

export const blockEvents = (events = []) => typeOfEvents(events, EVENT_TYPES.block);

export const flexibleEvents = (events = []) => typeOfEvents(events, EVENT_TYPES.flexible);

export const continuousEvents = (events = []) => typeOfEvents(events, EVENT_TYPES.continuous);

export const onDemandEvents = (events = []) => typeOfEvents(events, EVENT_TYPES.onDemand);

export const isFlexPlus = (event) =>
  event?.typeOf === EVENT_TYPES.flexible && Boolean(event?.flexSettings?.active);

export const hasAppointmentBookingItem = (event) =>
  (event?.bookingItems || []).some((bookingItem) => bookingItem.type === "appointment");

export const leadTimeToDuration = (hours) => {
  if (hours % (24 * 30) === 0 && hours >= 24 * 30) {
    return { unit: "months", count: hours / (24 * 30) };
  }
  if (hours % (24 * 7) === 0 && hours >= 24 * 7) {
    return { unit: "weeks", count: hours / (24 * 7) };
  }
  if (hours % 24 === 0 && hours >= 48) {
    return { unit: "days", count: hours / 24 };
  }
  return { unit: "hours", count: hours };
};
